import React, { useEffect, useState } from "react";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import LineBtn from "../../../../../Button/LineBtn";
import { CalendarLine } from "../../../ChatInfo/Old/OldRecentChat";
import {
  copyTextToClipboard,
  getMatchMakingSubsOptionList,
} from "../../../../../../AdminApi/commFunc";
import CalendarModalBtn from "../../../../../Button/CalendarModalBtn";
import AlertModal from "../../../../../Modal/AlertModal";
import styled from "styled-components";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../../ApiTS/ServiceDatasTS";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { decryptPW } from "../../../../../../Api/ApiCommon";
import { getSubsNameBySubsId3 } from "../../../../../../AdminApi/3.0_utils";
import { GetSubscriptionSetData_V3 } from "../../../../../../ApiTS/ServiceDatasTS_V3";

interface MatchMakingPartyInputModalProps extends DefaultModalCommonProps {}

export default function MatchMakingPartyInputModal({
  closeEvent,
  confirmEvent,
}: MatchMakingPartyInputModalProps) {
  const [subscription, setSubscription] = useState({
    value: "",
    label: "Subscription 선택",
  });
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState("날짜 선택");
  const [askModal, setAskModal] = useState(false);
  const [account, setAccount] = useState({
    value: "",
    label: "계정 선택",
  });
  const [partyMember1, setPartyMember1] = useState({
    value: "",
    label: "모집 인원 선택",
  });
  const [partyMember2, setPartyMember2] = useState({
    value: "",
    label: "모집 인원 선택",
  });
  const [accountListFetch, setAccountListFetch] = useState(false);
  const [accountOptionList, setAccountOptionList] = useState<OptionType[]>([]);
  const [partyMemberOptionList, setPartyMemberOptionList] = useState<
    OptionType[]
  >([]);
  const [makeParty, setMakeParty] = useState(false);
  const [errorModal, setErrorModal] = useState({
    exceed: false,
  });

  const {
    response: accountResponse,
    loading: accountLoading,
    error: accountError,
  } = useApi({
    method: "get",
    url:
      accountListFetch && subscription?.value !== ""
        ? `matchParty/assign?servsubsid=${subscription?.value}`
        : undefined,
  });

  const justOnePartySubs = [
    31000, 33000, 1100, 1190, 4100, 5100, 36000, 36100, 38000,28000
  ].includes(+subscription?.value!);

  const { response, loading, error } = useApi({
    method: "post",
    url: makeParty ? "matchParty" : undefined,
    data: {
      servsubsid: +subscription?.value,
      startdate: startDate,
      enddate: endDate,
      emailId: +account?.value,
      member:
        // 일부는1개 파티만 사용한다. (링고키즈, 추가공유, 추가공유 1190)
        justOnePartySubs
          ? [+partyMember1?.value]
          : [+partyMember1?.value, +partyMember2?.value],
    },
  });

  const selectedAccount = accountResponse?.data?.list?.find(
    (a: { email: string }) => a.email === account?.label,
  );

  useEffect(() => {
    if (subscription?.value !== "") {
      setEndDate("날짜 선택");
      setAccount({
        value: "",
        label: "계정 선택",
      });
      setPartyMember1({
        value: "",
        label: "모집 인원 선택",
      });
      setPartyMember2({
        value: "",
        label: "모집 인원 선택",
      });
      const subsId = +subscription?.value;
      const subsData = GetSubscriptionSetData_V3(subsId ?? 0);

      const optionList: OptionType[] = [];

      if (subsData?.POL_SHARMX && subsData?.POL_SHARMX > 0) {
        Array(subsData?.POL_SHARMX - 1)
          .fill(1)
          .forEach((_, i) => {
            optionList.push({
              value: String(i + 1),
              label: `${i + 1}명`,
            });
          });

        setPartyMemberOptionList(optionList);
      }
    }
  }, [subscription?.value]);

  useEffect(() => {
    if (accountResponse?.status === 200) {
      if (
        accountResponse?.data?.list &&
        accountResponse?.data?.list?.length > 0
      ) {
        const list: OptionType[] = [];
        accountResponse?.data?.list?.forEach(
          (l: { email: string; id: number }) => {
            list.push({
              value: `${l.id}`,
              label: l.email,
            });
          },
        );

        setAccountOptionList(list);
      } else if (accountResponse?.data?.list?.length === 0) {
        setAccountOptionList([]);
        toast.error("선택 가능한 이메일이 없습니다.");
      }
      setAccountListFetch(false);
    }
  }, [accountResponse]);

  useEffect(() => {
    if (response?.data?.result === 0) {
      toast.success("매치메이킹 파티가 생성되었습니다.");
      if (confirmEvent) confirmEvent();
      closeEvent();
    } else if (response?.data?.result === 1) {
      setErrorModal({
        exceed: true,
      });
    }
  }, [response]);

  useEffect(() => {
    if (error || accountError) {
      toast.error(
        error?.data ??
          accountError?.data ??
          (error
            ? "매치메이킹 파티 생성에 실패하였습니다."
            : accountError
              ? "선택 가능한 이메일을 불러오는 데에 실패하였습니다."
              : ""),
      );
    }
  }, [error, accountError]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="매치메이킹 파티 추가"
        confirmEvent={() => setAskModal(true)}
        closeEvent={() => closeEvent()}
        confirmBtnText="파티 만들기"
        cancelBtnText="취소"
        confirmDisabled={
          subscription?.value === "" ||
          startDate === "날짜 선택" ||
          endDate === "날짜 선택" ||
          account?.value === "" ||
          partyMember1?.value === "" ||
          (!justOnePartySubs && partyMember2?.value === "")
        }
      >
        <ModalRow>
          <ModalLabel>Subscription</ModalLabel>

          <ModalRowContentContainer>
            <DropDown
              boxWidth={240}
              optionList={getMatchMakingSubsOptionList()}
              dropdownValue={subscription}
              setDropDownValue={setSubscription}
            />

            <LineBtn
              btnText="바로가기"
              btnHeight={38}
              disabled={subscription?.value === ""}
              btnClickEvent={() => {
                const subsData = GetSubscriptionSetData_V3(
                  +subscription?.value ?? 0,
                );
                const svcData = GetServiceSetData(subsData?.SVC_ID ?? 0);

                window.open(svcData?.SVC_URL ?? "");
              }}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>파티 기간 설정</ModalLabel>

          <ModalRowContentContainer>
            <CalendarModalBtn
              calendar={{
                value: startDate,
                initValue: dayjs().format("YYYY-MM-DD"),
                minWidth: 150,
                disabled: true,
              }}
              modal={{
                changeEvent: (date) => setStartDate(date),
                dateValue: dayjs().format("YYYY-MM-DD"),
                isAfter: {
                  value: 1,
                  unit: "day",
                },
              }}
            />

            <CalendarLine />

            <CalendarModalBtn
              calendar={{
                value: endDate,
                initValue: "날짜 선택",
                minWidth: 150,
                disabled: startDate === "날짜 선택",
              }}
              modal={{
                changeEvent: (date) => setEndDate(date),
                dateValue: startDate,
                indefiniteOption: {
                  enabled: true,
                  label: "무기한",
                  value: "9999-12-31",
                },
              }}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>이메일 아이디</ModalLabel>

          <ModalRowContentContainer>
            <div
              onClick={() => {
                if (!(subscription?.value === "")) {
                  setAccountListFetch(true);
                }
              }}
            >
              <DropDown
                boxWidth={198}
                isDisabled={subscription?.value === ""}
                dropdownValue={account}
                setDropDownValue={setAccount}
                optionList={accountOptionList}
              />
            </div>

            <LineBtn
              btnText="복사"
              btnHeight={38}
              disabled={account?.value === ""}
              btnClickEvent={() =>
                copyTextToClipboard(
                  account?.label,
                  "이메일 아이디가 복사되었습니다.",
                )
              }
            />
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>비밀번호</ModalLabel>

          <ModalRowContentContainer>
            <ModalFixedBox>
              {selectedAccount?.password
                ? decryptPW(
                    selectedAccount?.password!,
                    +subscription?.value === 31000 ||
                      +subscription?.value === 33000
                      ? 3
                      : 1,
                  )?.pw
                : "-"}
            </ModalFixedBox>

            <LineBtn
              btnText="복사"
              btnHeight={38}
              disabled={selectedAccount?.password === ""}
              btnClickEvent={() =>
                copyTextToClipboard(
                  decryptPW(
                    selectedAccount?.password!,
                    +subscription?.value === 31000 ||
                      +subscription?.value === 33000
                      ? 3
                      : 1,
                  )?.pw,
                  "비밀번호가 복사되었습니다.",
                )
              }
            />
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow style={{ alignItems: "flex-start" }}>
          <ModalLabel>모집 인원 설정</ModalLabel>

          <div style={{ width: "calc(100% - 106px)" }}>
            <ModalRowContentContainer>
              <Party>파티 A</Party>

              <DropDown
                boxWidth={160}
                isDisabled={subscription?.value === ""}
                dropdownValue={partyMember1}
                setDropDownValue={setPartyMember1}
                optionList={partyMemberOptionList}
              />
            </ModalRowContentContainer>

            {!justOnePartySubs && (
              <ModalRowContentContainer style={{ marginTop: 10 }}>
                <Party>파티 B</Party>

                <DropDown
                  boxWidth={160}
                  isDisabled={subscription?.value === ""}
                  dropdownValue={partyMember2}
                  setDropDownValue={setPartyMember2}
                  optionList={partyMemberOptionList}
                />
              </ModalRowContentContainer>
            )}
          </div>
        </ModalRow>
      </DefaultModalLayout>

      {(loading || accountLoading) && <Loader />}

      {askModal && (
        <AlertModal
          title={"매치메이킹 파티를 만드시겠습니까?"}
          pointDesc={`서비스: ${
            subscription?.label?.split("_")[1]
          }\n파티 기간: ${startDate} ~ ${endDate}`}
          confirmEvent={() => {
            setMakeParty(true);
            setAskModal(false);
          }}
          cancelEvent={() => setAskModal(false)}
          btnColor="red"
          confirmText="파티 만들기"
        />
      )}

      {errorModal?.exceed && (
        <AlertModal
          title={"모집 가능 인원을 초과했어요"}
          desc={`${getSubsNameBySubsId3(
            +subscription?.value!,
          )}은 2개 파티원 합산 총 ${
            GetSubscriptionSetData_V3(+subscription?.value!)?.POL_SHARMX
          }명까지 모집 가능`}
          confirmEvent={() =>
            setErrorModal({
              exceed: false,
            })
          }
          confirmText="재설정 하기"
          customCancelBtn={<></>}
        />
      )}
    </>
  );
}

const Party = styled.span`
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #1e1e1e;
`;
